import React from "react";
import { Twitter, Github, Linkedin } from '@styled-icons/boxicons-logos';
import { ToSecondaryAnchor } from './styleComponents/HoverStyles'
import { Boop } from './animatedComponents/Boop.js';


const SocialIcons = () => (
  <>
    <ToSecondaryAnchor
      href="https://twitter.com/JayMGurav"
      aria-label="twitter profile"
      target="_blank"
      rel="nofollow noopener noreferrer"
    >
      <Boop y={-6}>
        <Twitter size="24" title="Twitter" />
      </Boop>
    </ToSecondaryAnchor>
    <ToSecondaryAnchor
      href="https://www.linkedin.com/in/jaymgurav/"
      aria-label="Linkedin profile"
      target="_blank"
      rel="nofollow noopener noreferrer"
    >
      <Boop y={-6}>
        <Linkedin size="24" title="Linkedin" />
      </Boop>
    </ToSecondaryAnchor>
    <ToSecondaryAnchor
      href="https://github.com/JayMGurav"
      className="nostyle"
      aria-label="github profile"
      target="_blank"
      rel="nofollow noopener noreferrer"
    >
      <Boop y={-6}>
        <Github size="24" title="Github" />
    </Boop>
    </ToSecondaryAnchor>
  </>
)

export default SocialIcons;